var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "批量编辑",
        visible: _vm.visible,
        width: "600px",
        "before-close": _vm.handleClose,
        "append-to-body": "",
        "custom-class": "batch-edit-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        { ref: "form", attrs: { model: _vm.form, "label-width": "120px" } },
        [
          _c("el-form-item", { attrs: { label: "微信公众号用户:" } }, [
            _c(
              "div",
              { staticClass: "upload-section" },
              [
                _c(
                  "el-upload",
                  {
                    ref: "upload",
                    attrs: {
                      "auto-upload": false,
                      "on-change": _vm.handleFileChange,
                      "show-file-list": false,
                      accept: ".xlsx,.xls",
                    },
                  },
                  [
                    _c("el-button", { attrs: { size: "small" } }, [
                      _vm._v("选择导入"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.form.fileName
              ? _c("div", { staticClass: "file-info" }, [
                  _c(
                    "div",
                    { staticClass: "file-name" },
                    [
                      _c(
                        "el-link",
                        {
                          attrs: { type: "primary", underline: false },
                          on: { click: _vm.handleDownloadFile },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.form.fileName) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm.form.userCount
                    ? _c("div", { staticClass: "user-count" }, [
                        _vm._v("用户数: " + _vm._s(_vm.form.userCount)),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
          ]),
          _c(
            "el-form-item",
            { attrs: { label: "标签操作:" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.operationType,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "operationType", $$v)
                    },
                    expression: "form.operationType",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: "add" } }, [_vm._v("新增")]),
                  _c("el-radio", { attrs: { label: "delete" } }, [
                    _vm._v("删除"),
                  ]),
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { "margin-top": "16px" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: { click: _vm.handleSelectTags },
                    },
                    [_vm._v("\n          选择标签\n        ")]
                  ),
                ],
                1
              ),
              _vm.form.submitItems.length > 0
                ? _c(
                    "div",
                    { staticClass: "selected-tags" },
                    _vm._l(_vm.form.submitItems, function (tag) {
                      return _c(
                        "el-tag",
                        {
                          key: tag.wechatTagId,
                          staticStyle: {
                            "margin-right": "8px",
                            "margin-top": "8px",
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(tag.wechatTagName) +
                              "\n        "
                          ),
                        ]
                      )
                    }),
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [
            _vm._v("取 消"),
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.loading },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v("提交并同步")]
          ),
        ],
        1
      ),
      _c("TagSelectionDialog", {
        attrs: {
          visible: _vm.tagSelectionVisible,
          wechatTags: _vm.form.selectedTagIds,
        },
        on: {
          "update:visible": function ($event) {
            _vm.tagSelectionVisible = $event
          },
          submit: _vm.handleTagSelectionSubmit,
        },
      }),
      _c("SyncResultDialog", {
        ref: "syncResultDialog",
        attrs: {
          visible: _vm.syncResultVisible,
          isDeleteMode: _vm.form.operationType === "delete",
        },
        on: {
          "update:visible": function ($event) {
            _vm.syncResultVisible = $event
          },
          cancel: _vm.handleSyncCancel,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }